import { Box } from '@mui/material';

export const SpacerGustio = ({ height = 0, width = 0 }) => {
  return (
    <Box sx={{ height: height, width: width}} />
  );
};
